import {
  GAMING_LIMITS_PANEL_QUERY_KEY,
  GAMING_LIMITS_PANEL_QUERY_VALUE,
  GAMING_LIMITS_PROFILE_PATH,
} from './gaming-limits.constants';

interface SearchParamReader {
  get: (key: string) => string | null;
}

export const isGamingLimitsPanelRequested = (
  searchParams: SearchParamReader
): boolean =>
  searchParams.get(GAMING_LIMITS_PANEL_QUERY_KEY) ===
  GAMING_LIMITS_PANEL_QUERY_VALUE;

export const removeGamingLimitsPanelRequest = (
  searchParams: string
): URLSearchParams => {
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete(GAMING_LIMITS_PANEL_QUERY_KEY);
  return nextSearchParams;
};

export const getGamingLimitsProfilePath = (): string => {
  const searchParams = new URLSearchParams({
    [GAMING_LIMITS_PANEL_QUERY_KEY]: GAMING_LIMITS_PANEL_QUERY_VALUE,
  });

  return `${GAMING_LIMITS_PROFILE_PATH}?${searchParams.toString()}`;
};
